module.exports = {
    ErrorCode: {
        Success: 0,
        Empty: 1,
        CookieInvalid: 1101
    },
    Subject: {
        1: '语文',
        2: '数学',
        3: '英语',
        4: '物理',
        5: '化学',
        6: '生物',
        7: '政治',
        8: '历史',
        9: '地理',
        10: '奥数'
    },
    WeekDay: {
        0: '星期日',
        1: '星期一',
        2: '星期二',
        3: '星期三',
        4: '星期四',
        5: '星期五',
        6: '星期六'
    },
    WeekDaySinple: {
        0: '周日',
        1: '周一',
        2: '周二',
        3: '周三',
        4: '周四',
        5: '周五',
        6: '周六',
        7: '周日'
    },
    StudyPhase: {
        1: '初一',
        2: '初二',
        3: '初三',
        4: '初四',
        5: '高一',
        6: '高二',
        7: '高三'
    },
    Grade: {
        1: '小学',
        2: '初中',
        3: '高中',
        4: '大学',
        11: '小学一年级',
        12: '小学二年级',
        13: '小学三年级',
        14: '小学四年级',
        15: '小学五年级',
        16: '小学六年级',
        17: '小学三年级以下',
        21: '初一',
        22: '初二',
        23: '初三',
        24: '初四',
        31: '高一',
        32: '高二文',
        33: '高二理',
        34: '高三文',
        35: '高三理',
        41: '大一',
        42: '大二',
        43: '大三',
        44: '大四'
    },
    // Grade以后不用了，用Grade2
    Grade2: {
        21: '初一',
        22: '初二',
        23: '初三',
        24: '初四',
        31: '高一',
        32: '高二文',
        33: '高二理',
        34: '高三文',
        35: '高三理',
        14: '小学四年级',
        15: '小学五年级',
        16: '小学六年级',
        17: '小学三年级以下'
    },
    // 教师类型
    TeachingType: {
        1: '在职老师',
        2: '专职老师',
        3: '兼职老师'
    },
    // 教师身份
    TeachingIdentity: {
        1: '在职老师',
        2: '机构老师',
        3: '全职老师',
        4: '大学生(实习)',
        5: '大学生(在校)',
        6: '基地专职',
        7: '网络专职',
        8: '慧学全职',
        9: '慧学兼职'
    },
    StudentType: {
        1: '试听',
        2: '正式'
    },
    FdGrade: {
        21: '初一',
        22: '初二',
        23: '初三',
        24: '初四',
        31: '高一',
        32: '高二',
        33: '高三',
        14: '小学四年级',
        15: '小学五年级',
        16: '小学六年级',
        17: '小学三年级以下'
    },
    FreeLessonSetupState: {
        0: '待定',
        1: '成功',
        2: '未试讲',
        3: '还在跟进中',
        4: '失败：价钱贵',
        5: '失败：试听不满意',
        6: '失败：不知道原因',
        7: '失败：学生原因',
        8: '取消安排',
        9: '失败：谈单原因'
    },
    // 学段
    Period: {
        1: '小学',
        2: '初中',
        3: '高中'
    },
     // 学段
     PeriodItems: {
        '小学': 1,
        '初中': 2,
        '高中': 3
    },
    // 学段
    PeriodText: {
        14: '四年级',
        15: '五年级',
        16: '六年级',
        17: '三年级以下',
        21: '初一',
        22: '初二',
        23: '初三',
        24: '初四',
        31: '高一',
        32: '高二',
        33: '高三'
    },

    SubjectText: {
        1: '语文',
        2: '数学',
        3: '英语',
        4: '物理',
        5: '化学',
        6: '生物',
        7: '政治',
        8: '历史',
        9: '地理',
        10: '奥数'
    },

    SubjectStr: {
        '语文': 1,
        '数学': 2,
        '英语': 3,
        '物理': 4,
        '化学': 5,
        '生物': 6,
        '政治': 7,
        '历史': 8,
        '地理': 9,
        '奥数': 10
    },

    // 试题类型
    QuestionStyle: {
        1: '单选题',
        2: '多选题',
        3: '主观题'
    },

    FlipQuestionStyle: {
        '选择题': 1,
        '单选题': 1,
        '多选题': 2,
        '主观题': 3,
        '填空题': 3
    },

    QuestionFrom: {
        kb: 1,
        custom: 2,
        hfs: 3,
        yp: 4
    },

    // 课节类型
    LessonType: {
        1: '试听课',
        2: '正式课',
        3: '答疑课'
    },
    PictureFrom: {
        1: '在线讲义-知识库',
        2: '在线讲义-自定义上传',
        3: '在线讲义-知识卡片',
        4: '普通图片',
        5: '在线讲义',
        10: '课件图片'

    },
    UserType: {
        1: '老师',
        2: '学生',
        3: '家长'
    },
    // 答疑课
    // 是否出错
    SessionMadeMistakes: {
        1: '完全正确（20分）',
        2: '出现细小错误（10分）',
        3: '出现重大错误（0分）'
    },
    // 讲解思路
    SessionTeachingLogic: {
        1: '解题思路非常清晰（40分）',
        2: '解题思路清晰（35分）',
        3: '解题思路一般（30分）',
        4: '没有解题思路（20分）'
    },
    // 互动引导
    SessionInteractionStatus: {
        1: '互动引导良好（20分）',
        2: '互动引导一般（15分）',
        3: '没有互动引导（10分）'
    },
    // 书写版面
    SessionWritingStatus: {
        1: '书写整洁清晰（10分）',
        2: '书写杂乱（5分）'
    },
    // 上课环境
    SessionClassEnvironment: {
        1: '上课环境良好（10分）',
        2: '上课环境嘈杂（0分）'
    },
    // 正式课或者试听课
    // 课堂讲解
    SessionClassroomInstruction: {
        1: '讲解条理非常清晰、生动形象（30分）',
        2: '讲解思路比较清晰、比较生动（25分）',
        3: '讲解思路混乱、复杂难懂（15分）',
        4: '关键点把握不准，讲解出错（5分）'
    },
    // 课堂内容
    SessionClassContent: {
        1: '知识讲解、题目讲解内容和先后顺序非常符合学生的学情（20分）',
        2: '知识讲解、题目讲解内容和先后顺序比较符合学生学情（18分）',
        3: '知识讲解、题目讲解内容和先后顺序混乱、不符合学生学情（15分）',
        4: '整节课的题目过难或者过易（12分）'
    },
    // 课堂结构
    SessionContentStructure: {
        1: '课堂结构非常符合本节课的课程定位（15分）',
        2: '课程结构比较符合本节课的课程定位（12分）',
        3: '课程结构混乱、没有形成有效的教学闭环（10分）'
    },
    // 课堂互动
    SessionClassInteraction: {
        1: '积极引导学生，发现问题并解决（15分）',
        2: '正向引导，解决问题不及时（13分）',
        3: '没有发现学生问题（10分）',
        4: '缺乏互动交流，全程老师讲解（8分）'
    },
    // 课堂效果
    SessionClassResult: {
        1: '学生全部掌握并灵活运用（10分）',
        2: '学生能够掌握大部分题型（8分）',
        3: '学生能够掌握小部分题型（7分）',
        4: '学生没有理解或掌握（5分）'
    },
    // 课堂板书
    SessionClassWriting: {
        1: '书写非常工整，布局非常合理，课堂具有节奏感（10分）',
        2: '书写比较工整，布局比较合理，课堂节奏感一般（8分）',
        3: '书写脏乱，布局不清，普通话不标准（5分）'
    },
    // 绑定关系
    BoundRelationship: {
        1: '正式',
        2: '试听',
        3: '未绑定'
    },
    FreeLessonLinkIntegrityType: {
        LESSON_INTO: 1, // 课程导入
        KNOWLEDGE_EXPLAIN: 2, // 知识讲解
        EXAMPLE_QUESTION_EXPLAIN: 3, // 例题讲解
        APPLY_PRACTICE: 4, // 应用练习
        LESSON_SUMMARY: 5, // 课堂大总结
        NEXT_LESSON_NOTICE: 6, // 规划预期
        OPEN_WORDS: 7, // 开场寒暄
        VERIFY: 8, // 确认预判
        PROVE_QUESTION: 9, // 原题证明
        END_WORDS: 10 // 结束语
    },
    // 正式课环节完整性
    FormalLessonLinkIntegrityType: {
        LESSON_INTO: 1, // 课程导入
        KNOWLEDGE_EXPLAIN: 2, // 知识讲解
        EXAMPLE_QUESTION_EXPLAIN: 3, // 例题讲解
        APPLY_PRACTICE: 4, // 应用练习
        LESSON_SUMMARY: 5, // 课堂小结
        NEXT_LESSON_NOTICE: 6, // 下节课预告
        PRE_LESSON_PREPARE: 7, // 课前准备
        HOMEWORK_DEAL: 8, // 作业处理
        LESSON_REVIEW: 9 // 复习回顾
    },

    // 整体课程情况
    SessionOverallSituation: {
        BOARD_WRITE: 1, // 课堂板书
        INTERACTION: 2, // 课堂沟通
        INDIVIDUATION: 3, // 个性化
        PROFESSIONAL_AND_AUTHORITY: 4 // 专业性和权威性
    },
    ExamType: {
        1: '期中考试',
        2: '期末考试',
        3: '月考',
        4: '竞赛',
        5: '普通考试',
        6: '联考',
        7: '单元测试',
        8: '模块检测',
        9: '专项复习',
        10: '入学考',
        11: '问卷'
    },
    QuestionSource: {
        1: '知识库题目',
        2: '图片题目',
        3: '试卷题目'
    },
    ClassPackageUnitProjectProgress: {
        1: '已学完',
        2: '正在学',
        3: '即将学',
        4: '尚未学'
    },
    // 个人待办
    PersonalStandby: {
        1: '填写课程日志',
        2: '布置作业',
        3: '批改作业',
        4: '做考试分析',
        5: '推送测评',
        6: '批改测评',
        7: '了解考试详情',
        8: '打分',
        9: '填写规划', // 旧版试听规划
        10: '查看规划', // 业务修改课程规划
        11: '查看测评报告',
        12: '推送测评',
        13: '查看测评报告',
        14: '编辑考试冲刺卷',
        15: '查看考试冲刺卷报告'
    },
    // 课程类型
    courseType: {
        AUDITION: 1, // 试听课
        FORMAL: 2, // 正式课
        ANSWERING: 3 // 答疑课
    },
    // 跟进者用户类型
    FollowerType: {
        1: '无',
        2: '咨询师',
        3: '班主任',
        4: '学管师',
        5: '规划师',
        6: '运营'
    },
    // 规划课时包学段
    TeachingGrade: {
        11: '小学',
        21: '初中',
        31: '高中'
    },
    TeacherCharacter: { // 老师个性标签
        'steady': '稳重',
        'humor': '幽默',
        'lively': '活泼',
        'relaxed': '轻松',
        'cheerful': '开朗',
        'patient': '耐心',
        'mild': '温和',
        'rigorous': '严谨'
    },
    // 教学资历
    TeachingExperience: {
        1: '中考阅卷评审员',
        2: '中考考点把握精准',
        3: '高考阅卷评审员',
        4: '高考考点把握精准',
        5: '名校教师',
        6: '名牌大学毕业',
        7: '学科带头人',
        8: '学科知识渊博',
        9: '解题达人'
    },
    // 课堂氛围
    TeacherStyle: {
        1: '轻松',
        2: '愉快',
        3: '活泼',
        4: '条理严谨',
        5: '幽默有趣',
        6: '善于互动'
    },
    // 教学理念
    TeachingIdea: {
        1: '强规划重实施',
        2: '反对填鸭式教学',
        3: '化繁为简重技巧',
        4: '注重学生的心理发展'
    },
    // 教学风格
    TeachingStyle: {
        1: '课堂内容生动不死板',
        2: '课堂气氛活跃',
        3: '和力强',
        4: '引导式教学',
        5: '幽默风趣',
        6: '年轻时尚',
        7: '喜欢倾听学生的声音'
    },
    // 老师学历
    TeacherEducation: {
        '1': '专科',
        '2': '本科',
        '3': '硕士',
        '4': '博士'
    },
    // 教师等级
    TeacherLevel: {
        110: 'P0', // P0-初级
        112: 'P1', // P1-中级一级
        120: 'P2', // P2-中级二级
        180: 'P3', // P3-中级三级
        121: 'P4', // P4-中级四级
        190: 'P5', // P5-高级一级
        191: 'P6', // P6-高级二级
        122: 'P7', // P7-高级三级
        130: 'P8', // P8-特级一级
        131: 'P9', // P9-特级二级
        132: 'P10', // P10-特级三级
        140: 'P11', // P11-教授一级
        141: 'P12', // P12-教授二级
        142: 'P13' // P13-教授二级
    },
    TeacherTags: {
        DAKESHI: '大课时', // 大课时
        SHUANGKESHI: '双课时', // 双课时
        DAIXUFEI: '待续费', // 待续费
        JIEKEYUJING: '结课预警', // 结课预警
        JIEKE: '结课', // 结课
        TINGKEYUJING: '停课预警', // 停课预警
        TINGKE: '停课', // 停课
        TUIFEI: '退费', // 退费
        LIUSHI: '流失' // 流失
    },
    // 补课状态
    MakeUpStatus: {
        NONE: 'none', // 不需要补课
        NEED: 'need', // 需要补课
        DONE: 'done'
     }, // 已补完课
    NewTeachingType: {
        1: '兼职老师',
        2: '全职老师',
        3: 'pre-专职老师',
        4: '专职老师',
        5: '慧学空间老师'
    },
    RecommendMode: {
        'completely_personalized': '完全个性化',
        'personalized_school': '个性化本校分层',
        'personalized_region': '个性化地区分层',
        'school': '本校分层',
        'region': '地区分层'
    },
    // Grade2映射到FdGrade
    GradeToFdGrade: {
        21: 21,
        22: 22,
        23: 23,
        24: 24,
        31: 31,
        32: 32,
        33: 32,
        34: 33,
        35: 33,
        14: 14,
        15: 15,
        16: 16,
        17: 17
    },
    CheckQuestionResult: {
        1: '正确',
        2: '半对',
        3: '错误',
        4: '未批改'
    },
    StudentLevels: {
        5: 'A',
        4: 'B',
        3: 'C',
        2: 'D',
        1: 'E'
    },
    PersonCuoti: [
        '课后作业错题',
        '课中错题',
        '阶段测评错题',
        '课前小练错题',
        '智能练习错题',
        '爆破练错题',
        '冲刺卷错题',
        '追踪卷错题',
        '追踪测错题',
        '学前测错题'
    ],
    CapsuleType: {
        '同步学习胶囊': 'SYNC_STUDY_CAPSULE',
        '专题学习胶囊': 'PROJECT_STUDY_CAPSULE',
        '考试爆破胶囊': 'EXAM_CLAST_CAPSULE'
    },
    CoursewareQuestionOrigin: {
        DMP_JIAOYAN: 'dmp_jiaoyan', // dmp教研编辑
        DMP_RECOMMEND: 'dmp_recommend', // dmp系统推荐
        AI_RECOMMEND: 'ai_recommend', // 算法个性化推荐
        MANUAL_HOMEWORK: 'manual_homework', // 手动插入作业
        MANUAL_STAGE_EVALUATION: 'manual_stage_evaluation', // 手动插入阶段测评
        MANUAL_EXAM: 'manual_exam', // 手动插入考试题目
        MANUAL_KB: 'manual_kb', // 手动插入题库题目
        MANUAL_TEACHING_PROGRESS: 'manual_teaching_progress', // 手动插入，当地教学进展
        UNKNOWN: 'unknown'
    },
    // 胶囊错题类型筛选
    CapsuleErrorQuestionType: {
        beforeEvaluation: '学前测',
        afterEvaluation: '追踪测',
        consolidation: '巩固练习',
        beforeClass: '课前小练',
        depostTopic: '考前冲刺卷',
        capacity: '智能练习',
        depostTopicMistakes: '考前冲关练',
        mistakes: '错题精练',
        traceMistakes: '考后错题练'
    },
    // --------------------------- v辅导v4.44.2 新规则及结算逻辑调整 时添加
    // 连线进入课堂行为
    SessionLoginAct: {
        STUDENT_LOGIN: 's-login', // 仅学生进入课堂
        TEACHER_LOGIN: 't-login', // 仅老师进入课堂
        ALL_LOGIN: 'all_login', // 双方都已进入课堂
        ALL_NOT_LOGIN: 'all_not_login' // 双方都未进入课堂
    },

    // 老师课时记录类型
    TeacherPeriodRecordType: {
        CLASS_FEE: 1, // 课时费
        ABSENT: 2, // 旷课处罚
        LATE: 3, // 迟到15min以上处罚
        CANCEL_CLOSE_CLASS: 4 // 取消12小时以内课程处罚
    },
    // 学校预测
    schoolList: {
        小学: [{
            name: '普通中学',
            class: 'zhongzhuan',
            img: 'home-icon-two'
        }, {
            name: '市重点',
            class: 'putonggaozhong',
            img: 'home-icon-three'
        }, {
            name: '省重点',
            class: 'shizhongdian',
            img: 'home-icon-four'
        }],
        初中: [{
            name: '不太理想',
            class: 'zhongzhuan',
            img: 'home-icon-one'
        }, {
            name: '普通高中',
            class: 'putonggaozhong',
            img: 'home-icon-two'
        }, {
            name: '市重点',
            class: 'shizhongdian',
            img: 'home-icon-three'
        }, {
            name: '省重点',
            class: 'shengzhongdian',
            img: 'home-icon-four'
        }],
        高中: [{
            name: '不太理想',
            class: 'zhongzhuan',
            img: 'home-icon-one'
        }, {
            name: '二本院校',
            class: 'putonggaozhong',
            img: 'home-icon-two'
        }, {
            name: '一本院校',
            class: 'shizhongdian',
            img: 'home-icon-three'
        }, {
            name: '双一流',
            class: 'shengzhongdian',
            img: 'home-icon-four'
        }]
    },
    // 课时包等级
    PackageLevel: {
        0: '',
        1: '基础',
        2: '高级',
        3: 'VIP'
    }
};




// WEBPACK FOOTER //
// ./src/constants/enum.js